<template>
    <div class="back-body">
        <div class="back-icon" @click="backAgo">
            <img src="../../assets/imgs/backBlack.png" alt="">
        </div>
        <div class="back-msg">{{msg}}</div>
    </div>
</template>

<script>
    export default {
        name: "bookback",
        props:['msg'],
        methods:{
            //返回上一页
            backAgo(){
                this.$router.back(-1)
            }
        }
    }
</script>

<style scoped>
    .back-body{
        width: 100%;
        height: 1rem;
        background: #ffffff;
        box-sizing: border-box;
        padding: 0 0.4rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 0.02rem solid #e6e6e6;
        position: relative;
    }
    .back-icon{
        width:0.19rem;
        height: 0.32rem;
        position: absolute;
        left: 0.4rem;
        top: 0;
        bottom: 0;
        margin-top: auto;
        margin-bottom: auto;
    }
    .back-icon img{
        width:0.19rem;
        height: 0.32rem;
        display: block;
    }
    .back-msg{
        width: 100%;
        height: 100%;
        font-size: 0.32rem;
        line-height: 1rem;
        color: #666666;
        font-weight: 700;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/bookback.vue